import PortugalContractType from 'modules/contracts/store/models/PortugalContractType'
import { PayrollLegalEntityResource } from 'modules/contracts/store/collections/payrollLegalEntityResource'

class ContractTypes extends PayrollLegalEntityResource<PortugalContractType> {
  get cacheKey(): string {
    return 'portugalContractTypes'
  }

  model() {
    return PortugalContractType
  }
}

export { ContractTypes }
